import {useEffect} from "react";
import imageDefault from 'assets/images/thankyou/tableta.png';
import imageSpecial from 'assets/images/thankyou/special_register_image.png';
import backgroundLogin from "assets/images/LogoWellbeing360.png";
import facebook from "assets/images/facebook.png";
import twitter from "assets/images/twitter.png";
import linkedin from "assets/images/linkedin.png";
import wats from "assets/images/whatsapp.png";
import {FormattedMessage} from "react-intl";
import $ from 'jquery';
import {config} from "../../config";
import ReactPixel from 'react-facebook-pixel';
import {useSearchParams, Link} from 'react-router-dom';

const ThankYou = () => {
    const [searchParams] = useSearchParams();
    const specialRegister = searchParams.get('specialRegister');

    useEffect(() => {
        window.scrollTo(0, 0);
        ReactPixel.track("THANK-YOU-PAGE")
    }, []);

    const twitterSubmit = (event) => {
        event.preventDefault();
        window.open(
            'http://twitter.com/share?url='+encodeURIComponent('https://www.wellbeing360.tv/'),
            'twitter-share-dialog','width=626,height=436'); return false;
    }

    const linkedinSubmit = (event) => {
        event.preventDefault();
        window.open(
            'https://www.linkedin.com/shareArticle?mini=true&amp;title=Evento%20virtual%20Wellbeing%20360&amp;url='
            +encodeURIComponent('https://www.wellbeing360.tv/'),
            'linkedin-share-dialog','width=626,height=436'); return false;
    }

    const facebookSubmit = (event) => {
        event.preventDefault();
        window.open(
            'https://www.facebook.com/sharer/sharer.php?u='+encodeURIComponent('https://www.wellbeing360.tv/'),
            'facebook-share-dialog','width=626,height=436'); return false;
    }

    return (
        <div className="image-width" style={specialRegister ? { backgroundColor: '#eee6db' } : {backgroundImage: `url(${config.cloudfront_image_category}/images/Back_TYP.jpg)`}}>
            <div className="container">
                <div className={`row margin-top-thank-you ${specialRegister ? 'align-items-center' : ''}`}>

                    <div className="col-md-5">
                        <img src={backgroundLogin} alt="Wellbeing360" className="img-fluid logo-thank-you"/>
                        {specialRegister ? (
                            <>
                                <h1 style={{ color: '#cb6015', fontWeight: 'bold', textTransform: 'none' }}>
                                    ¡Estás a un paso de terminar tu registro en la Escuela de Familias Positivas!
                                </h1>
                                <br/>
                                <p style={{ color: '#00534c' }}>
                                    Revisa tu bandeja de entrada, abre el correo electrónico que te enviamos y haz click sobre la liga e ingresa el código que te llego para terminar tu registro.
                                </p>
                                <p style={{ color: '#00534c' }}>
                                    Si no te llega el correo electrónico en la bandeja principal, puedes revisar en la carpeta de "correo no deseado o spam".
                                </p>
                                <div className="mt-4 pb-4">
                                    <Link to="/login?specialRegister=true" className="gen-button" style={{display: 'inline-flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', backgroundColor: '#cb6015', borderRadius: '25px', padding: '12px 40px', minWidth: '150px'}}>Inicia Sesión</Link>
                                </div>
                            </>
                        ) : (
                            <>
                                <h1 className="purple-text">
                                    <FormattedMessage
                                        id="thankYou_onestep"
                                        defaultMessage="¡Estás a un paso de terminar tu registro!"
                                    />
                                </h1>
                                <br/>
                                <p className="whiteThankyoupage-text" >
                                    <FormattedMessage
                                        id="thankYouMail_p1"
                                        defaultMessage="
                                            Se envío un correo de verificación, por favor
                                                verifique su bandeja de entrada"
                                    />                          
                                </p>
                                <p className="whiteThankyoupage-text" >                          
                                    <FormattedMessage
                                        id="thankYouMail_p2"
                                        defaultMessage="
                                            Se envío un correo de verificación, por favor
                                                verifique su bandeja de entrada"
                                    />
                                </p>
                                <p className="whiteThankyoupage-text" >                          
                                    <FormattedMessage
                                        id="thankYouMail_p3"
                                        defaultMessage="
                                            Se envío un correo de verificación, por favor
                                                verifique su bandeja de entrada"
                                    />
                                </p>
                                <p className="whiteThankyoupage-text">
                                    <FormattedMessage
                                        id="thankYouRegards"
                                        defaultMessage="¡Saludos!"
                                    />
                                </p>
                            </>
                        )}
                        <div id="compartir">
                            <div className="social-links social-right" style={specialRegister ? { backgroundColor: '#00534c', color: '#eee6db' } : {}}>
                                <div>
                                    <span className="pr-4" style={specialRegister ? { color: '#eee6db' } : {}}>
                                        <FormattedMessage
                                            id="thankYouInvite"
                                            defaultMessage=" Invita a una amiga o amigo disfrutar de nuestros videos. "
                                        /></span>
                                </div>
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-2">
                                        <div onClick={(event) => {facebookSubmit(event)}}>
                                            <img src={facebook}  alt="facebook" width="24px"/>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div
                                            onClick={(event) => {twitterSubmit(event)}}>
                                            <img src={twitter} alt="twitter" width="24px"/>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div
                                            onClick={(event) => {linkedinSubmit(event)}}>
                                            <img src={linkedin} alt="linkedin" width="24px"/>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <a target="_blank" href="https://api.whatsapp.com/send?text=Evento%20virtual%20Wellbeing%20360%20https://wellbeing360.mx/">
                                            <img src={wats} alt="whatsapp" width="24px" />
                                        </a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="col-md-6">
                        <img 
                            src={specialRegister ? imageSpecial : imageDefault} 
                            alt="Logo-Wellbeing" 
                            className="img-fluid"
                            style={specialRegister ? {} : {}}
                        />
                    </div>


                </div>
            </div>
        </div>
)
}

export default ThankYou;
